function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "nc1z3l03wa",
  width: "103.9%",
  height: "109.6%",
  x: "-2%",
  y: "-2.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowOffsetOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "vkhd8b39ib",
  d: "M31.964 14.687c.869-1.178 2.535-1.438 3.728-.585 1.2.858 1.468 2.52.594 3.704l-10.62 14.399c-.942 1.27-2.39 2.068-3.968 2.181-1.582.114-3.133-.472-4.247-1.601L11.96 27.21c-1.034-1.05-1.008-2.732.058-3.75 1.059-1.012 2.746-.987 3.774.056l5.503 5.584c.008.005.013.007.016.007.008 0 .023-.009.038-.029z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#46FF54",
  d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0z",
  transform: "translate(-152 -160) translate(152 160) translate(7.5 5)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-152 -160) translate(152 160) translate(7.5 5)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#nc1z3l03wa)",
  xlinkHref: "#vkhd8b39ib"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#vkhd8b39ib"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.243 -1.357L66.243 -1.357 66.243 29.043 6.243 29.043z",
  opacity: 0.429,
  transform: "translate(-152 -160) translate(152 160) translate(7.5 5) rotate(45 36.243 13.843)"
})))));

var SvgIconSuccess = function SvgIconSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-success.2a1e0fba.svg";
export { ForwardRef as ReactComponent };